import { wrapRequest } from './base';

const getShippingTrafficCreds = async (): Promise<{
  apiKey: string;
  tileId: string;
}> => wrapRequest('get', 'north_standard', '/shipping-traffic');

export default getShippingTrafficCreds;
